import { FormProvider } from 'react-hook-form';
import { Outlet } from 'react-router-dom';
import styles from './VisitNoteTemplateLayout.module.css';
import { useVisitNoteSubmit } from './hooks/useVisitNoteSubmit';
import { useVisitNoteTemplate } from './hooks/useVisitNoteTemplate';
import { useSubmitGuard } from '@/hooks/useSubmitGuard';
import { preventImplicitSubmit } from '@/utils/preventImplicitSubmit';

/**
 * Layout for the visit note template pages: provides the template form and submits it on
 * Publish. A repeated submit while the template is being published is ignored, and Enter
 * in a field does not submit it.
 * @returns The visit note template layout.
 */
export const VisitNoteTemplateLayout = () => {
  const { methods } = useVisitNoteTemplate();
  const { onSubmit, onError } = useVisitNoteSubmit();
  const guardedSubmit = useSubmitGuard(methods.handleSubmit(onSubmit, onError));

  return (
    <FormProvider {...methods}>
      <form
        aria-label="Visit Note Template Form"
        onSubmit={guardedSubmit}
        onKeyDown={preventImplicitSubmit}
        className={styles.container}
      >
        <Outlet />
      </form>
    </FormProvider>
  );
};
